/**
 * Copyright IBM Corp. 2019
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

// embed jquery and datatables.net
import './jquery-datatables';

export default from './index-jquery';
